import React from "react";
import { FontSizes } from "../../../styles/responsive";
import { PALLETTE } from "../../../utils/theme";

const quadrants = [
  { label: "QUADRANT 1", style: { top: "35%", left: "0%" } },
  { label: "QUADRANT 2", style: { top: "35%", right: "0%" } },
  { label: "QUADRANT 4", style: { bottom: "35%", left: "0%" } },
  { label: "QUADRANT 3", style: { bottom: "35%", right: "0%" } },
];

const QuadrantSeparate = () => {
  return (
    <div style={containerStyle}>
      <div style={verticalLineStyle} />
      <div style={horizontalLineStyle} />

      {quadrants.map((q, index) => (
        <span key={index} style={{ ...quadrantTextStyle, ...q.style }}>
          {q.label}
        </span>
      ))}
    </div>
  );
};

const containerStyle: React.CSSProperties = {
  position: "relative",
  height: 235,
  width: 160,
};

const verticalLineStyle: React.CSSProperties = {
  position: "absolute",
  left: "50%",
  top: 0,
  bottom: 0,
  width: 2,
  backgroundColor: PALLETTE.gray,
};

const horizontalLineStyle: React.CSSProperties = {
  position: "absolute",
  top: "50%",
  left: 0,
  right: 0,
  height: 2,
  backgroundColor: PALLETTE.gray,
};

const quadrantTextStyle: React.CSSProperties = {
  position: "absolute",
  fontSize: "1.10rem",
  color: PALLETTE.gray,
};

export default QuadrantSeparate;
